import { StyledTriangle } from './Triangle.styles'

const Triangle: React.FC = (): JSX.Element => {
    return <StyledTriangle />
}

export default Triangle
